// Maker Embed Script
(function() {
    // Create container if not exists
    function createContainer() {
        const container = document.createElement('div');
        container.id = 'cmciwvv1c009khs5rmi45dmla-root';
        container.className = 'cmciwvv1c009khs5rmi45dmla-app makerai-app';

        // Find the script tag
        const currentScript = document.currentScript;
        if (currentScript && currentScript.parentNode && currentScript.parentNode !== document.head) {
            currentScript.parentNode.insertBefore(container, currentScript);
        } else {
            document.body.appendChild(container);
        }
        return container;
    }

    function addMadeWithMakerLink(container) {
     return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = 'https://ai.maker.co';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'sticky';
        link.style.bottom = '8px';
        link.style.right = '8px';
        link.style.left = '8px';
        link.style.textDecoration = 'none';
        link.style.zIndex = '9999';
        link.style.display = 'block';
        link.style.height = '24px';
        link.style.width = 'fit-content';
        link.style.lineHeight = '24px';
        link.style.padding = '0 8px';
        link.style.borderRadius = '6px';
        link.style.backgroundColor = 'rgba(0, 0, 0, 0.60)';
        link.style.backdropFilter = 'blur(2px)';
        link.style.color = '#FFF';
        link.style.fontFamily = 'sans-serif';
        link.style.fontSize = '12px';
        link.style.fontWeight = '500';
        link.textContent = 'Made with maker';
        container.appendChild(link);
        resolve();
      });
    }

    // Load CSS file
    function loadCSS(href) {
        return new Promise((resolve, reject) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
        });
    }
    // Add custom style to head
    function addCustomStyle(css) {
        return new Promise((resolve, reject) => {
            const style = document.createElement('style');
            style.type = 'text/css';
            style.textContent = css;
            document.head.appendChild(style);
        });
    }

    // Load script and wait for it to be ready
    function loadScript(src, external = false, is_async = false, attrs = {}) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = src;           
            Object.entries(attrs).forEach(function(entry) {
              script.setAttribute(entry[0], entry[1]);
            });
            script.onload = () => {
                // Wait a small amount of time to ensure the script has executed
                setTimeout(resolve, 100);
            };
            script.onerror = reject;
            if (external) {
              script.type = 'text/javascript';
              document.head.appendChild(script);
            }else {
              document.body.appendChild(script);
            }
            if (is_async) {
              script.async = true;
            }
        });
    }

    function loadInlineScripts(type, scriptContent, tagName) {
      return new Promise((resolve, reject) => {
        try {
          const script = document.createElement(tagName);
          if (tagName == 'script') {
              script.type = type;
          }
          script.textContent = scriptContent;
          document.body.appendChild(script);
          // inline scripts execute immediately upon append; resolve on next tick
          setTimeout(resolve, 0);
        } catch (e) {
          reject(e);
        }
      });
    }

    // Initialize
    async function init() {
        // Get base URL from current script
        const scriptElement = document.currentScript;
        const baseUrl = scriptElement.src.split('/embed.js')[0];

        try {
            // For AB experiment: load posthog script first to ensure any tracking in inline scripts works
            await loadInlineScripts("text/javascript", `
      console.warn("Posthog tracking disabled for org", "user_2ZAtAYc1MFcL5x3zo53g47MXUVS");
      window.__mkr_ph = window.__mkr_ph || {};
      window.__mkr_ph['ph_devi_cmciwvv1c009khs5rmi45dmla'] = null;
    `, "script");

            // Create container
            const container = createContainer();

            // Load styles
            await Promise.all([
                loadCSS(`${baseUrl}/assets/main.css`)
            ]);

            // Load the main script and wait for it to be ready
            await loadScript(`${baseUrl}/assets/main.js`, false, true);

            // Add the Made with Maker link
            
            // Load any external scripts specified in the index.html
            
            // Load inline scripts from index.html
                      
            // Now that both container and script are ready, trigger DOMContentLoaded
            // This ensures main.jsx's DOMContentLoaded handler will find the container
            const domContentLoadedEvent = new Event('DOMContentLoaded');
            document.dispatchEvent(domContentLoadedEvent);

        } catch (error) {
            console.error('Failed to load devi widget:', error);
        }
    }

    // Run initialization
    init();
})();